const url = {
	API_BASE_URL: 'https://visitor-tracker-backend.adriit.com/api/'
};
export const server_config = url;
